export default __webpack_public_path__ + "80c02e8eb594f323285877250931a091.png";